import React from 'react'
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom'
import moment from 'moment'
import Header from './Header'
import Lobby from '../components/Lobby/Lobby.component'
import ChooseDevice from '../components/ChooseDevice/ChooseDevice.component';
import { isMobile } from 'react-device-detect'
import th from 'moment/locale/th'
import cn from 'moment/locale/zh-cn'
import en from 'moment/locale/es-us'

const RouteView = () => {
    const language = useSelector(state => state.language)

    if (language === 'th') {
        moment.updateLocale('th', [th])
    } else if (language === 'cn') {
        moment.updateLocale('zh-cn', [cn])
    } else {
        moment.updateLocale('en', [en])
    }

    return (
        <>
            {!isMobile
                ? <Header />
                : <div />
            }
            <Switch>
                <Route exact path="/lobbymanager/" component={isMobile ? ChooseDevice : Lobby} />
                <Route exact path="/lobbymanager/:roomName" component={isMobile ? ChooseDevice : Lobby} />
            </Switch>
            <div />
        </>
    )
}

export default RouteView